import React, { ReactNode, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AuthService } from '../../services/AuthService';
import AuthSelectors from '../../selectors/AuthSelectors';
import { FORBIDDEN_PATH } from '../../constants/route.constants';
import PrivateRoute from './PrivateRoute';
import { UserRole } from '../../common/constants/UserRoles';

type RoleBasedRouteProps = {
    children?: ReactNode;
    allowedRoles: UserRole[];
};

export default function RoleBasedRoute(
    props: RoleBasedRouteProps,
): JSX.Element {
    const { children, allowedRoles } = props;
    const accessToken = useSelector(AuthSelectors.getAuthToken);

    const isAllowed = useMemo(() => {
        for (const role of allowedRoles) {
            if (AuthService.hasUserRole(accessToken, role)) {
                return true;
            }
        }

        return false;
    }, [accessToken, allowedRoles]);

    if (!isAllowed) {
        return <Navigate to={FORBIDDEN_PATH} replace relative="path" />;
    }

    return <PrivateRoute>{children}</PrivateRoute>;
}
